<template>
  <div>

    <!-- 图片标题 -->
    <div class="">
      <div class="pannel-pay-title">
        <img src="/imgs/title_dev.jpg" />
      </div>
    </div>

    <!-- 订单号 -->
    <OrderIdComp :order-info="orderInfo" />

    <!-- 付款流程 -->
    <div class="pannel">
      <div class="pay-flow">
        <p style="color: #4CAF50;"><b>注意：</b></p>
        <p class="no">本通道尚未配置！！！</p>
      </div>
    </div>

    <!-- 倒计时 -->
    <TimerComp2 :order-info="orderInfo" :pay-time-info="payTimeInfo" />

    <!-- time tips -->
    <TimeTipsComp :order-info="orderInfo" />

    <!-- 警告事项 -->
    <div class="pannel-simp attention">
      <p class="">注意：<span style="color: red;">本通道尚未配置！！！</span>本通道尚未配置！！！</p>
    </div>

  </div>

</template>

<script>
import * as apis from "@/apis/apis";
//
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
//
export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      ifSub: false,
    };
  },
  computed: {},
  created() {},
  methods: {
    // 测试已支付
    devPayd() {
      this.ifSub = true;
      apis
        .devPayd({
          id: this.orderInfo.orderId,
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
</style>
